var _document_querySelectorAll;
var $promotionModal = document.getElementById('promotion').querySelector('.modal__container');
var $promotionValue = document.querySelector('[data-promotion-id]');
var $promotionContent = document.querySelector('[data-promotion-content]');
window.addEventListener('load', function() {
    var _window_location_search_substring_split, _window_location_search_substring;
    var request = (_window_location_search_substring = window.location.search.substring(1)) === null || _window_location_search_substring === void 0 ? void 0 : (_window_location_search_substring_split = _window_location_search_substring.split('&')) === null || _window_location_search_substring_split === void 0 ? void 0 : _window_location_search_substring_split.map(function(item) {
        return item.split('=');
    }).find(function(item) {
        return item[0] === 'promotion';
    });
    if (request) {
        window.lenis.scrollTo('#promotions', {
            duration: 0,
            lerp: 0
        });
        setTimeout(function() {
            var _Array_from_find;
            (_Array_from_find = Array.from(document.querySelectorAll('[data-promotion-more]')).find(function(item) {
                return item.dataset.promotionMore === request[1];
            })) === null || _Array_from_find === void 0 ? void 0 : _Array_from_find.dispatchEvent(new CustomEvent('click'));
        }, 1000);
    }
});
(_document_querySelectorAll = document.querySelectorAll('[data-promotion-more]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
    $item.addEventListener('click', function(event) {
        event.preventDefault();
        var id = $item.dataset.promotionMore;
        window.history.pushState(null, null, "?promotion=".concat(id));
        $promotionModal.classList.add('-loading');
        window.modal.open('promotion');
        fetch("".concat(api.promotion, "?id=").concat(id)).then(function(response) {
            return response.json();
        }).then(function(response) {
            $promotionValue.value = id;
            $promotionContent.innerHTML = '\n					<div class="promotion-more__image">\n						<img src="'.concat(response.image, '" alt="">\n						').concat(response.tags.length > 0 ? '\n									<div class="promotion-more__tags">\n										'.concat(response.tags.map(function(tag) {
                return "<span>".concat(tag, "</span>");
            }).join(''), "\n									</div>\n								") : '', '\n					</div>\n					<div class="promotion-more__title">').concat(response.title, "</div>\n					").concat(response.text ? '<div class="promotion-more__text">'.concat(response.text, "</div>") : '', '\n					<div class="promotion-more__link"><a href="').concat(response.link, '">подробнее</a></div>\n				');
            $promotionModal.classList.remove('-loading');
        });
    });
});
window.addEventListener('modalAfterClose', function(event) {
    if (event.detail.id === 'promotion') {
        $promotionValue.value = '';
        $promotionContent.innerHTML = '';
        window.history.pushState(null, null, window.location.pathname);
    }
});
